var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.346,
    height: 18.5,
    viewBox: "0 0 14.346 18.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125",
    transform: "translate(-1154.259 -5443.412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document-outline",
    transform: "translate(1154.509 5443.662)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M11.769,18H2.077A2.077,2.077,0,0,1,0,15.923V2.077A2.077,2.077,0,0,1,2.077,0H6.349a1.387,1.387,0,0,1,.361.048V5.634a1.5,1.5,0,0,0,1.5,1.5H13.8a1.385,1.385,0,0,1,.048.36h0v8.426A2.077,2.077,0,0,1,11.769,18ZM13.777,7.067l-7-7a1.393,1.393,0,0,1,.549.337L13.44,6.518a1.389,1.389,0,0,1,.337.549Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocFilled);
export default __webpack_public_path__ + "static/media/doc-filled.337411a28d081f3ece84107f060bd830.svg";
export { ForwardRef as ReactComponent };